import { Sheet } from '@sunwebgroup/uds-ui/sheet';
import { useUdsToken } from '@sunwebgroup/uds-ui/utils';
import { AdvancedMarker, APIProvider, Map as GoogleMap } from '@vis.gl/react-google-maps';
import * as React from 'react';
import { useIntl } from '@/intl';
import { ActiveMarker } from '@/scopes/common/components/Markers/ActiveMarker';
import { GOOGLE_MAP_ID } from '@/scopes/common/constants/GoogleMapId';
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider';
import { NewRelicErrorBoundary } from '@/scopes/common/infrastructure/logging/NewRelicErrorBoundary';
import styles from './AccommodationMap.module.css';

interface AccommodationMapProperties {
  lat: number;
  lng: number;
  title: string;
  children: React.ReactNode;
}

export function AccommodationMap({ lat, lng, title, children }: AccommodationMapProperties) {
  const intl = useIntl();
  const markerColor = useUdsToken<string>('primitives_color_primary_500');
  const googleMapsApiKey = useConfiguration('thirdParties.googleMapsApiKey');

  return (
    <Sheet.Root>
      <Sheet.Trigger>{children}</Sheet.Trigger>
      <Sheet.Body side="bottom" hasPadding={false}>
        <Sheet.Header closeLabel={intl.formatMessage({ id: 'close' })} titleLabel={title} />
        <Sheet.Content className={styles.sheetContent}>
          <APIProvider apiKey={googleMapsApiKey ?? ''}>
            <GoogleMap
              mapId={GOOGLE_MAP_ID}
              defaultZoom={15}
              defaultCenter={{ lat, lng }}
              reuseMaps
              fullscreenControl={false}
              headingInteractionEnabled={false}
              clickableIcons={false}
            >
              <AdvancedMarker zIndex={1000} position={{ lat, lng }}>
                <ActiveMarker color={markerColor} />
              </AdvancedMarker>
            </GoogleMap>
          </APIProvider>
        </Sheet.Content>
      </Sheet.Body>
    </Sheet.Root>
  );
}
